import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m25.125 28.754 7.33-7.505c.333-.332 1.209-.332 1.54 0 .332.332.333 1.17 0 1.5l-7.85 7.832a2.975 2.975 0 0 1-4.206-.003l-7.845-7.846c-.332-.332-.332-1.151 0-1.483.332-.332 1.063-.332 1.395 0l7.386 7.47V8.35c0-1.133 2.25-1.133 2.25 0v20.404Zm13.618-2.404c0-.47.64-.85 1.11-.85.47 0 1.047.38 1.047.85 0 2.993-.12 5.85-.361 8.57a5.95 5.95 0 0 1-5.457 5.407c-3.978.315-7.687.473-11.127.473-3.453 0-7.198-.159-11.234-.476a5.95 5.95 0 0 1-5.46-5.408A97.291 97.291 0 0 1 6.9 26.35c0-.47.632-.85 1.101-.85.47 0 1.077.38 1.077.85 0 2.943.118 5.748.354 8.416.183 2.067 1.354 3.287 3.422 3.45 3.994.314 7.694.471 11.1.471 3.395 0 7.059-.156 10.994-.467 2.067-.164 3.258-1.383 3.44-3.45a95.31 95.31 0 0 0 .355-8.42Z",
      clipRule: "evenodd"
    }
  )
);
var SvgImportOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ImportOutlined_default = SvgImportOutlined;

export { ImportOutlined_default as default };
